import styled, { keyframes } from "styled-components";
import { mediaMax } from "components/designV2/breakpoints";
import { Radius, Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";

export const ContractContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.xl}px;
  width: 100%;
`;

export const ContractActions = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ContractSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
`;

export const ContractFields = styled.div`
  background: ${ColorV2.Blue7};
  border-radius: ${Radius.xl}px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ContractFieldRow = styled.div`
  align-items: center;
  border-bottom: 1px solid ${ColorV2.White};
  display: flex;
  gap: ${Spacing.lg}px;
  justify-content: space-between;
  padding: ${Spacing.md}px ${Spacing.lg}px;

  &:last-child {
    border-bottom: 0;
  }

  ${mediaMax.mobile} {
    align-items: flex-start;
    flex-direction: column;
    gap: ${Spacing.xs}px;
  }
`;

export const ContractDescriptionField = styled(ContractFieldRow)`
  align-items: flex-start;
  flex-direction: column;
  gap: ${Spacing.xs}px;
  white-space: pre-line;
`;

export const ContractLoading = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 240px;
  width: 100%;
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const ContractSpinner = styled.div`
  animation: ${spin} 0.8s linear infinite;
  border: 3px solid ${ColorV2.Blue6};
  border-radius: 50%;
  border-top-color: ${ColorV2.Blue1};
  height: 32px;
  width: 32px;
`;
